import {
  FilterProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  PageViewProvider,
  Flex,
} from "dash-ui";

import AddPropertyToPortfolioModal from "containers/portfolio/AddPorpertyToPortfolioModal/AddPropertyToPortfolioModal";

import PropertiesContentView from "./components/PropertiesContentView/PropertiesContentView";
import PropertiesTopBar from "./components/PropertiesTopBar/PropertiesTopBar";

const AllPropertiesListContainer = () => (
  <PaginationProvider>
    <SearchProvider>
      <SortProvider>
        <PageViewProvider>
          <FilterProvider>
            <Flex w="100%" h="100%" flexDirection="column">
              <PropertiesTopBar />
              <PropertiesContentView />
              <AddPropertyToPortfolioModal />
            </Flex>
          </FilterProvider>
        </PageViewProvider>
      </SortProvider>
    </SearchProvider>
  </PaginationProvider>
);

export default AllPropertiesListContainer;
